import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import Modal from '../Modal'
import { addPreferredLane, updatePreferredLane } from '../../redux/preferredLane/preferredLanesActions'
import ConfirmationDialog from '../ConfirmationDialog'
import LaneForm from './LaneForm'

const AddLaneModal = ({ open, laneToEdit, onClose }) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(null)

  const dispatch = useDispatch()

  const handleConfirmationDialog = useCallback((action) => {
    const payload = { ...confirmationDialogOpen }
    if (action) {
      if (payload.lane_id) {
        dispatch(updatePreferredLane(payload, onClose))
      } else {
        dispatch(addPreferredLane(payload, onClose))
      }
    }
    setConfirmationDialogOpen(null)
  }, [dispatch, onClose, confirmationDialogOpen])

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      title={`${laneToEdit?.lane_id ? 'Edit' : 'New'} Lane` || ''}
    >
      <LaneForm
        lane={laneToEdit}
        onSave={setConfirmationDialogOpen}
        onClose={onClose}
      />

      <ConfirmationDialog
        open={Boolean(confirmationDialogOpen)}
        title={`${laneToEdit ? 'Edit' : 'Add'} Lane`}
        description='Are sure you want to save this lane?'
        onClose={handleConfirmationDialog}
      />
    </Modal>
  )
}

AddLaneModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  laneToEdit: PropTypes.object
}

AddLaneModal.defaultProps = {
  open: false,
  onClose: () => {},
  laneToEdit: null
}

export default AddLaneModal
